export const requestEarlyAccess = () =>
  window.open("https://forms.gle/hn1RkweQDoJd9EGu8", "_blank");
